// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ot-1";
export var stateContainer = "_ot-0";